(function(){
  if(window.__alvaSizeCompare)return;
  window.__alvaSizeCompare=true;
  var backdropPress=null;
  function isBackdrop(event,dialog){
    if(event.target!==dialog)return false;
    var bounds=dialog.getBoundingClientRect();
    return event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom;
  }
  document.addEventListener('pointerdown',function(event){
    var dialog=event.target.closest('dialog.alva-size-compare[open]');
    backdropPress=dialog&&isBackdrop(event,dialog)?dialog:null;
  });
  document.addEventListener('click',function(event){
    var backdropDialog=backdropPress;
    backdropPress=null;
    if(backdropDialog&&backdropDialog.open&&isBackdrop(event,backdropDialog)){
      backdropDialog.close();
      return;
    }
    var opener=event.target.closest('[data-alva-size-compare-open]');
    if(opener){
      var dialog=document.getElementById(opener.dataset.alvaSizeCompareOpen);
      if(dialog&&!dialog.open)dialog.showModal();
      return;
    }
    var choice=event.target.closest('[data-alva-size-compare-choose]');
    if(!choice)return;
    var input=document.getElementById(choice.dataset.alvaSizeCompareChoose);
    if(!input||input.disabled||choice.disabled)return;
    var modal=choice.closest('dialog');
    if(modal)modal.close();
    input.click();
    input.focus({preventScroll:true});
  });
})();